// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"46":"SapiMagicSortOverlay","230":"confirmation","764":"payment","923":"roomselection"}[chunkId] || chunkId) + "." + {"46":"b3a1db73","230":"d14d302b","531":"404f202b","593":"404f202b","764":"87224b25","923":"85679f0e"}[chunkId] + ".chunk.css";
};